/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertStatus, IAlert } from './alert-types';

@Component({
  selector: 'alert',
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
  standalone: false
})

export class AlertComponent {
  @Input() alert: IAlert;
  @Output() alertClosed = new EventEmitter<void>();

  public get alertClass(): { [key: string]: boolean } {
    return {
      'alert-error': this.alert.type === AlertStatus.Error,
      'alert-warning': this.alert.type === AlertStatus.Warning,
      'alert-info': this.alert.type === AlertStatus.Info,
      'alert-success': this.alert.type === AlertStatus.Success,
    };
  }

  public get title(): string {
    if (!this.alert.title || this.alert.title.trim() === '') {
      switch (this.alert.type) {
        case AlertStatus.Error:
          return 'Error';
        case AlertStatus.Warning:
          return 'Warning';
        case AlertStatus.Info:
          return 'Information';
        case AlertStatus.Success:
          return 'Success';
        default:
          return 'Alert';
      }
    }
    return this.alert.title;
  }

  public get message(): string {
    return this.alert.message;
  }

  public get icon(): string {
    switch (this.alert.type) {
      case AlertStatus.Error:
        return 'cancel_circle';
      case AlertStatus.Warning:
        return 'warning';
      case AlertStatus.Info:
        return 'info';
      case AlertStatus.Success:
        return 'check_circle';
      default:
        return 'info';
    }
  }

  public get isCloseButtonVisible(): boolean {
    return this.alert.isDismissable ?? false;
  }

  public get hasMaxHeight(): boolean {
    return this.alert.maxHeight !== undefined;
  }
  
  constructor() { }

  public hideAlert(): void {
    this.alertClosed.emit();
  }
}
